var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live"},[_c('iframe',{attrs:{"id":"myIframe","src":_vm.link,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }